import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './loan-affordability-calculators.component.scss';
var LoanAffordabilityCalculators = /** @class */ (function (_super) {
    tslib_1.__extends(LoanAffordabilityCalculators, _super);
    function LoanAffordabilityCalculators(element) {
        return _super.call(this, element) || this;
    }
    LoanAffordabilityCalculators.prototype.init = function () {
    };
    LoanAffordabilityCalculators.prototype.bindEvents = function () {
    };
    return LoanAffordabilityCalculators;
}(Base));
export { LoanAffordabilityCalculators };



//////////////////
// WEBPACK FOOTER
// ./components/loan-affordability-calculators/loan-affordability-calculators.component.ts
// module id = 1129
// module chunks = 0